import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Constants } from '../../shared/Constants';

@Injectable()
export class ProviderService {

  constructor(private http: HttpClient) { }

  listProviders() {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.get(Constants.URL_BACKEND + '/providers', { headers: headers });
  }

  getProviderByName(name) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.get(Constants.URL_BACKEND + '/providerFilterNombre?name=' + name, { headers: headers });
  }

  getProvider(id) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.get(Constants.URL_BACKEND + '/prividerFilter?id=' + id, { headers: headers });
  }

  createProvider(providerData) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));

    return this.http.post(Constants.URL_BACKEND + '/providers', { data: providerData }, { headers: headers });
  }

  updateProvider(idProvider, updateProvider) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.put(Constants.URL_BACKEND + '/providers/' + idProvider, { data: updateProvider }, { headers: headers });
  }

  deleteProvider(idProvider) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.delete(Constants.URL_BACKEND + '/providers/' + idProvider, { headers: headers });
  }
}



// WEBPACK FOOTER //
// ./src/app/system/services/provider.service.ts